import { Wrench, Users, UserCircle2, IdCard, Handshake, PackageOpen, Server, Layers } from "lucide-react";

/** Meaningful icon per known service, keyed to serviceColors.js's KNOWN map. */
const SERVICE_ICONS = {
  FSM: Wrench,
  HRMS: Users,
  ESS: UserCircle2,
  CRM: IdCard,
  PSM: Server,
  IMS: PackageOpen,
  PM: Handshake,
};

/**
 * svc.name can be a compound label like "HRMS Team" or "HRMS ESS" rather
 * than a bare code, so match a known key against individual words (checked
 * last-to-first, since the trailing word tends to be the more specific one,
 * e.g. "ESS" in "HRMS ESS") before falling back to a plain substring check.
 */
export function getServiceIcon(name) {
  if (!name) return Layers;
  const words = String(name).trim().toUpperCase().split(/\s+/);

  for (let i = words.length - 1; i >= 0; i -= 1) {
    if (SERVICE_ICONS[words[i]]) return SERVICE_ICONS[words[i]];
  }

  const upper = words.join(" ");
  const matchedKey = Object.keys(SERVICE_ICONS).find((key) => upper.includes(key));
  return matchedKey ? SERVICE_ICONS[matchedKey] : Layers;
}

